import classNames from "classnames";
import React, { useEffect } from "react";
import EntityForm from "modules/entity/forms";
import { useSelector } from "react-redux";
import useAlert from "hooks/useAlert";
import { get, last } from "lodash";
import useTranslation from "hooks/useTranslation";
import { Field } from "formik";
import { Fields } from "uicomponents";
import { Button, Input, Segmented, Switch } from "antd";
import useAutoReducer from "useAutoReducer";
import { api } from "services/index";
import { helpers } from "../services";

const SelectLanguage = ({ value, onChange }) => {
	return (
		<Segmented
			size="middle"
			value={value}
			onChange={onChange}
			options={[
				{ label: "O'z", value: "uz" },
				{ label: "Ру", value: "ru" },
				{ label: "En", value: "en" },
				{ label: "Zh", value: "zh" }
			]}
		/>
	);
};

const SelectTextSize = ({ value, onChange, tr }) => {
	return (
		<Segmented
			size="middle"
			value={value}
			onChange={e => onChange(e)}
			options={[
				{
					label: tr("Стандартный"),
					value: "sm"
				},
				{
					label: tr("Большой"),
					value: "md"
				},
				{
					label: tr("Очень большой"),
					value: "lg"
				}
			]}
		/>
	);
};

const SelectTextAlign = ({ value, onChange, tr }) => {
	return (
		<Segmented
			size="middle"
			value={value}
			onChange={e => onChange(e)}
			options={[
				{
					label: tr("Влево"),
					value: "left"
				},
				{
					label: tr("В центр"),
					value: "center"
				},
				{
					label: tr("Вправо"),
					value: "right"
				}
			]}
		/>
	);
};

const SelectTextFont = ({ value, onChange, tr }) => {
	return (
		<Segmented
			value={value}
			onChange={onChange}
			size="middle"
			options={[
				{
					label: tr("Стандартный"),
					value: "normal"
				},
				{
					label: tr("Жирный"),
					value: "bold"
				}
			]}
		/>
	);
};

const translateValues = {
	ru: {
		_current: "Текущий",
		_paymentType: "Форма оплаты:",
		_estimated_quantity: "Примерное количество",
		_cash: "Наличные:",
		_card: "Терминал:",
		_chequeType: "Тип чека",
		_purchase: "Покупка",
		_fiskalInfo: "Фискальная информация",
		_virtualKassaSR: "Виртуальная касса С/Р:",
		_fmNumber: "ФМ номер:",
		_fiskalSign: "Фискальный знак:",
		_copy: "**** Копия ****",
		_VAT: "НДС",
		_MXIK: "ИКПУ",
		_leftover: "Остаток",
		_price_for_a_quantity: "Цена за 1 (кг, шт, л …)",
		_menu: "Меню",
		_chef: "Шеф",
		_product: "Продукт",
		_unit: "Ед. изм.",
		_hour: "час",
		_minute: "мин",
		_comment: "Комментарий",
		_placePrice: "Цена место",
		_deliveryPrice: "Цена доставки",
		_rejected: "Отменено",
		_newOrder: "Новый заказ",
		_orderNumber: "Номер заказа",
		_orderType: "Тип заказа",
		_table: "Стол",
		_place: "Место",
		_waiter: "Кассир",
		_client: "Клиент",
		_client_phone: "Номер клиента",
		_time: "Время",
		_date: "Дата",
		_tableNumber: "Номер стола",
		_phoneNumber: "Номер телефона",
		_address: "Адрес",
		_productName: "Наименование",
		_quantity: "Кол-во",
		_price: "Цена",
		_total: "Итого",
		_subtotal: "Подытог",
		_balance: "Баланс клиента",
		_debt: "Долг клиента",
		_current_balance: "Текущий баланс",
		_current_debt: "Текущий долг",
		_discount: "Скидка",
		_productDiscount: "Скидка на товары",
		_payAmount: "Сумма к оплате",
		_refund: "Сдачи",
		_paid_amount: "Оплаченна",
		_total_vat: "Итого НДС",
		_products: "Продукты c обслуживаний",
		_productsWithoutTip: "Продукты без обслуживаний",
		_staff: "Обслуживание",
		_type: {
			delivery: "Доставка",
			book: "Бронь",
			take: "С собой",
			unset: "Не указан"
		}
	},
	uz: {
		_current: "Joriy",
		_estimated_quantity: "Taxminiy miqdor",
		_paymentType: "To'lov shakli:",
		_cash: "Naqd:",
		_card: "Terminal:",
		_chequeType: "Check turi",
		_purchase: "Xarid",
		_fiskalInfo: "Fiskal ma'lumot",
		_virtualKassaSR: "Virtual kassa S/R:",
		_fmNumber: "FM raqami:",
		_fiskalSign: "Fiskal belgi:",
		_copy: "**** Копия ****",
		_VAT: "QQS",
		_MXIK: "МХИК",
		_leftover: "Qolgan",
		_price_for_a_quantity: "Narxi (1 kg, 1 dona, 1 l …)",
		_menu: "Menyu",
		_chef: "Oshpaz",
		_product: "Mahsulot",
		_unit: "O'lch.b.",
		_hour: "soat",
		_minute: "daqiqa",
		_comment: "Izoh",
		_placePrice: "Joy narxi",
		_deliveryPrice: "Yetkazib berish narxi",
		_rejected: "Bekor qilindi",
		_newOrder: "Yangi buyurtma",
		_orderNumber: "Buyurtma raqami",
		_orderType: "Buyurtma turi",
		_table: "Stol",
		_place: "Joy",
		_waiter: "Kassir",
		_client: "Mijoz",
		_client_phone: "Mijoz raqami",
		_time: "Vaqt",
		_date: "Sana",
		_tableNumber: "Stol raqami",
		_phoneNumber: "Telefon raqam",
		_address: "Manzil",
		_productName: "Nomi",
		_quantity: "Miqdor",
		_price: "Narx",
		_total: "Jami",
		_subtotal: "Jami",
		_balance: "Mijoz balansi",
		_debt: "Mijoz qarzi",
		_current_balance: "Hozirgi balansi",
		_current_debt: "Hozirgi qarzi",
		_discount: "Chegirma",
		_productDiscount: "Mahsulotlar chegirmasi",
		_payAmount: "To'lov summasi",
		_refund: "Qaytim",
		_paid_amount: "To'landi",
		_total_vat: "Jami QQS",
		_products: "Mahsulotlar xizmat haqqi bilan",
		_productsWithoutTip: "Mahsulotlar xizmat haqqisiz",
		_staff: "Xizmat",
		_type: {
			delivery: "Yetkazib berish",
			book: "Bron",
			take: "Olib ketish",
			unset: "Ko'rsatilmagan"
		}
	},
	en: {
		_current: "Current",
		_estimated_quantity: "Estimated quantity",
		_paymentType: "Payment Type:",
		_cash: "Cash:",
		_card: "Card:",
		_chequeType: "Cheque Type",
		_purchase: "Purchase",
		_fiskalInfo: "Fiscal Information",
		_virtualKassaSR: "Virtual Cash Register S/R:",
		_fmNumber: "FM Number:",
		_fiskalSign: "Fiscal Sign:",
		_copy: "**** Copy ****",
		_VAT: "VAT",
		_MXIK: "IPIA",
		_leftover: "Leftover",
		_price_for_a_quantity: "Price (1 kg, 1 pc, 1 l …)",
		_menu: "Menu",
		_chef: "Chef",
		_product: "Product",
		_unit: "Unit",
		_hour: "hour",
		_minute: "min",
		_comment: "Comment",
		_placePrice: "Place price",
		_deliveryPrice: "Delivery Price",
		_rejected: "Rejected",
		_newOrder: "New order",
		_orderNumber: "Order number",
		_orderType: "Order type",
		_table: "Table",
		_place: "Place",
		_waiter: "Waiter",
		_client: "Client",
		_client_phone: "Client phone",
		_time: "Time",
		_date: "Date",
		_tableNumber: "Table number",
		_phoneNumber: "Phone number",
		_address: "Address",
		_productName: "Name",
		_quantity: "Qty",
		_price: "Price",
		_total: "Total",
		_subtotal: "Subtotal",
		_balance: "Client balance",
		_debt: "Client debt",
		_current_balance: "Current balance",
		_current_debt: "Current debt",
		_discount: "Discount",
		_productDiscount: "Product discount",
		_payAmount: "Payment amount",
		_refund: "Refund",
		_paid_amount: "Paid amount",
		_total_vat: "Total VAT",
		_products: "Products with service",
		_productsWithoutTip: "Products without service",
		_staff: "The staff",
		_type: {
			delivery: "Delivery",
			book: "Book",
			take: "Take away",
			unset: "Not set"
		}
	},
	zh: {
		_current: "当前",
		_paymentType: "付款方式:",
		_cash: "现金:",
		_card: "刷卡:",
		_chequeType: "支票类型",
		_purchase: "购买",
		_fiskalInfo: "财务信息",
		_virtualKassaSR: "虚拟收银机 S/R:",
		_fmNumber: "FM编号:",
		_fiskalSign: "财务标志:",
		_copy: "**** 副本 ****",
		_VAT: "增值税",
		_MXIK: "IPIA",
		_leftover: "剩余",
		_price_for_a_quantity: "单价 (1 kg, 1 件, 1 l …)",
		_menu: "菜单",
		_chef: "厨师",
		_product: "产品",
		_unit: "单位",
		_hour: "小时",
		_minute: "分钟",
		_comment: "评论",
		_placePrice: "地点价格",
		_deliveryPrice: "配送费",
		_rejected: "已取消",
		_newOrder: "新订单",
		_orderNumber: "订单编号",
		_orderType: "订单类型",
		_table: "桌子",
		_place: "地点",
		_waiter: "出纳员",
		_client: "客户",
		_client_phone: "客户电话",
		_time: "时间",
		_date: "日期",
		_tableNumber: "桌号",
		_phoneNumber: "电话号码",
		_address: "地址",
		_productName: "商品名称",
		_quantity: "数量",
		_price: "价格",
		_total: "总计",
		_subtotal: "小计",
		_balance: "客户余额",
		_debt: "客户债务",
		_current_balance: "当前余额",
		_current_debt: "当前债务",
		_discount: "折扣",
		_productDiscount: "产品折扣",
		_payAmount: "应付金额",
		_refund: "退款",
		_paid_amount: "已付金额",
		_total_vat: "增值税总额",
		_products: "带服务的产品",
		_productsWithoutTip: "不含服务的产品",
		_staff: "服务",
		_type: {
			delivery: "外送",
			book: "预订",
			take: "自取",
			unset: "未指定"
		}
	}
};

const initialChequeState = {
	logo: {
		order: 1,
		isActive: true
	},
	companyName: {
		order: 2,
		isActive: true,
		text: "Atmosfera Leaf",
		size: "sm", // "sm" | "md" | "lg"
		align: "left", // "left" | "center" | "right"
		font: "normal" // "normal" | "bold"
	},
	orderNumber: {
		order: 3,
		isActive: true,
		size: "sm", // "sm" | "md" | "lg"
		align: "left", // "left" | "center" | "right"
		font: "normal" // "normal" | "bold"
	},
	orderDate: {
		order: 4,
		isActive: true,
		size: "sm", // "sm" | "md" | "lg"
		align: "left", // "left" | "center" | "right"
		font: "normal" // "normal" | "bold"
	},
	orderType: {
		order: 5,
		isActive: true
	},
	orderTable: {
		order: 6,
		isActive: true
	},
	waiter: {
		order: 7,
		isActive: true
	},
	service: {
		order: 8,
		isActive: true
	},
	totalSum: {
		order: 9,
		isActive: true,
		size: "sm", // "sm" | "md" | "lg"
		font: "normal" // "normal" | "bold"
	},
	totalSumDetails: {
		order: 10,
		isActive: true
	},
	comment: {
		order: 11,
		isActive: true,
		text: "XARIDINGIZ UCHUN RAXMAT!",
		size: "sm", // "sm" | "md" | "lg"
		align: "left", // "left" | "center" | "right"
		font: "normal" // "normal" | "bold"
	},
	qrcode: {
		order: 12,
		isActive: true
	},
	bottomOrderNumber: {
		order: 13,
		isActive: false
	},
	goodList: {
		isActive: true,
		order: 14,
		isCompact: true
	},
	chequeLanguage: {
		isActive: true,
		order: 15,
		language: "ru"
	}
};
export const ChequeBuilder = () => {
	const { tr } = useTranslation();
	const { showAlert } = useAlert();
	const organization = useSelector(state => state.auth.selected_organization);

	const [state, send] = useAutoReducer({
		...initialChequeState,
		currChequeId: null
	});

	const lang = state.chequeLanguage.language || "ru";
	const tVals = translateValues[lang] || translateValues.ru;

	useEffect(() => {
		try {
			api
				.request({
					url: `/organization-cheques`
				})
				.then(res => {
					const lastChequeArr = last(res.data.data);
					const json = get(lastChequeArr, "json");

					if (json) send({ ...json, currChequeId: lastChequeArr.id });
				});
		} catch (error) {
			console.log(error);
		}
	}, []);

	const onSave = async values => {
		try {
			send({ isLoading: true });

			void (await Promise.all([
				await api.request({
					method: "PUT",
					url: `/user/organization/${organization.id}`,
					data: {
						logo_id: get(values, "file_id.id")
					}
				}),
				await api.request({
					url: state.currChequeId
						? `/organization-cheques/${state.currChequeId}`
						: `/organization-cheques`,
					method: state.currChequeId ? "PUT" : "POST",
					data: { json: state }
				})
			]));

			showAlert(tr("Успешно сохранено"), { type: "success" });
		} catch (error) {
			showAlert(tr("Ошибка отправки запроса"), { type: "danger" });
		}

		send({ isLoading: false });
	};

	const textAlign = align => {
		if (align === "left") return "text-left";
		if (align === "center") return "text-center";
		if (align === "right") return "text-right";
		return "";
	};
	const textSize = size => {
		if (size === "sm") return "text-base";
		if (size === "md") return "text-3xl";
		if (size === "lg") return "text-4xl";
		return "";
	};
	const textFont = font => {
		if (font === "normal") return "font-normal";
		if (font === "bold") return "font-bold";
		return "";
	};

	const chequeTopSecondaryData = [
		...(state.orderType.isActive
			? [{ title: tVals._orderType, value: tVals._type.take }]
			: []),
		...(state.waiter.isActive ? [{ title: tVals._waiter, value: tr("Kassir") }] : [])
	];

	return (
		<>
			<EntityForm.Main
				prependData={true}
				fields={[
					{
						name: "file_id",
						value: get(organization, "logo"),
						onSubmitValue: value => (value ? value.id : null)
					}
				]}
			>
				{({ values }) => {
					const imageSrc = get(values, "file_id.thumbnails.normal.src");

					return (
						<div className="grid grid-cols-12 gap-7 p-5 relative h-[1vh]">
							<div className="col-span-4 !py-5 font-mono relative">
								<div
									className="w-full font-mono p-4 bg-white sticky z-10 top-0"
									style={{
										boxShadow: "0px 0px 10px 0 rgba(0,0,0,0.07)"
									}}
								>
									<WaveTop />
									<WaveBottom />

									{state.logo.isActive ? (
										<div className="div h-48 w-full flex items-center justify-center bg-gray-100 | !mb-3">
											<img src={imageSrc} className="!h-full z-50" />
										</div>
									) : null}

									{state.companyName.isActive ? (
										<p
											className={classNames({
												"w-full my-0": true,
												[textAlign(state.companyName.align)]: true,
												[textSize(state.companyName.size)]: true,
												[textFont(state.companyName.font)]: true
											})}
										>
											{state.companyName.text}
										</p>
									) : null}

									{state.orderNumber.isActive ? (
										<p
											className={classNames({
												"w-full !my-0": true,
												[textAlign(state.orderNumber.align)]: true,
												[textSize(state.orderNumber.size)]: true,
												[textFont(state.orderNumber.font)]: true
											})}
										>
											{tVals._orderNumber}: 3
										</p>
									) : null}

									{state.orderDate.isActive ? (
										<p
											className={classNames({
												"w-full !my-0": true,
												[textAlign(state.orderDate.align)]: true,
												[textSize(state.orderDate.size)]: true,
												[textFont(state.orderDate.font)]: true
											})}
										>
											{/* {tVals._date}: 18:17 31.07.2026 */}
											{tVals._date}: {helpers.formatDate(new Date(), "HH:mm DD.MM.YYYY")}
										</p>
									) : null}

									{/* {chequeTopSecondaryData.length > 0 ? (
										<div className="h-[10px]" />
									) : null} */}
									<div className="border border-x-0 border-t-0 border-b-[1.5px] border-dashed !border-gray-500 pb-[10px]">
										{chequeTopSecondaryData.map(data => {
											return (
												<div className="flex items-center justify-between">
													<p className="my-0">{data.title}</p>
													<p className="my-0">{data.value}</p>
												</div>
											);
										})}
									</div>

									{/* {chequeTopSecondaryData.length > 0 ? (
										<div className="h-[20px]" />
									) : null} */}

									{/* <div className="flex border border-x-0 border-t-0 border-b-[1.5px] border-dashed !border-gray-500">
										{[
											{
												text: "Наименование",
												align: "LEFT",
												width: 39
											},
											{
												text: "Кол-во",
												align: "CENTER",
												width: 16
											},
											{
												text: "Цена",
												align: "RIGHT",
												width: 18
											},
											{
												text: "Итого",
												align: "RIGHT",
												width: 27
											}
										].map((data, idx) => {
											return (
												<p
													style={{ width: `${data.width}%` }}
													className={classNames({
														"my-0 py-3 font-bold": true,
														"text-left": data.align === "LEFT",
														"text-right": data.align === "RIGHT",
														"text-center": data.align === "CENTER"
													})}
												>
													{data.text}
												</p>
											);
										})}
									</div> */}

									<div className={
										classNames({
											"mt-[10px]": true,
											"": !state.goodList.isCompact
										})}>
										{
											[
												{
													title: "Shapka",
													price: "5000",
													quantity: "10",
													total: "50000"
												},
												{
													title: "Kurtka",
													price: "32000",
													quantity: "2",
													total: "64000"
												},
											].map((data, idx) => {
												return (
													<div className={classNames({
														"": true,
														"py-3 border border-x-0 border-t-0 border-b-[1.5px] border-dashed !border-gray-500": !state
															.goodList.isCompact
													})}>
														<p className="m-0">{`${idx + 1}.${tr(data.title)}`}</p>
														<div className="dotted-row">
															<p className="m-0 dotted-row-left">{`${data.quantity} x ${data.price}`}</p>
															<div className="dotted-border"></div>
															<p className="m-0 dotted-row-right">{helpers.formatNumber(data.total)}</p>
														</div>
													</div>
												);
											})
										}
									</div>

									{/* <div className="flex justify-between text-3xl font-bold mt-[10px]">
										<p
											className={classNames({
												"my-0": true,
												[textAlign(state.totalSum.align)]: true,
												[textSize(state.totalSum.size)]: true,
												[textFont(state.totalSum.font)]: true
											})}
										>
											Подытог
										</p>

										<p
											className={classNames({
												"my-0": true,
												[textAlign(state.totalSum.align)]: true,
												[textSize(state.totalSum.size)]: true,
												[textFont(state.totalSum.font)]: true
											})}
										>
											114 000
										</p>
									</div> */}

									<div className="dotted-row my-[15px]">
										<p className="dotted-row-left !m-0">{tVals._subtotal}</p>
										<div className="dotted-border"></div>
										<p className="m-0 dotted-row-right">114 000</p>
									</div>

									{/* <div className="dotted-row">
										<div className="flex justify-between border border-x-0 border-t-0 dotted-row-left">
											<div className="text-left w-full py-3 !font-sans !pr-2">
												Скидка
											</div>
											<div className="dotted-border"></div>
											<div className="text-right w-full py-3 !font-mono dotted-row-right">
												<span className="font-normal">10% 11 400</span>
												{state.service.isActive ? "8 000" : null}
											</div>
										</div>
									</div> */}

									{state.service.isActive ? (
										<div className="dotted-row">
											<p className="dotted-row-left !m-0">
												{tVals._discount}
											</p>
											<div className="dotted-border"></div>
											<p className="m-0 dotted-row-right">10% 11 400</p>
										</div>) : null}

									<div className="border border-x-0 border-t-0 border-b-[1.5px] border-dashed !py-2 !border-gray-500">
										{state.totalSum.isActive ? (
											<div className="dotted-row">
												<p
													className={classNames({
														"dotted-row-left !m-0": true,
														[textSize(state.totalSum.size)]: true,
													})}
												>
													{tVals._total}
												</p>
												<div className="dotted-border"></div>
												<p
													className={classNames({
														"m-0 dotted-row-right": true,
														[textSize(state.totalSum.size)]: true,
													})}
												>
													102 600
												</p>
											</div>
										) : null}

										{state.totalSumDetails.isActive ? (
											<>
												<div className="h-[10px]" />

												<div className="dotted-row">
													<div className="dotted-row-left !m-0">
														{tVals._cash}
													</div>
													<div className="dotted-border"></div>
													<div className="dotted-row-right">100 000</div>
												</div>

												<div className="dotted-row">
													<div className="dotted-row-left !m-0">
														{tVals._card}
													</div>
													<div className="dotted-border"></div>
													<div className="dotted-row-right">2 600</div>
												</div>
											</>
										) : null}
									</div>

									{state.comment.isActive ? (
										<p
											className={classNames({
												"w-full !my-0 !py-3": true,
												[textAlign(state.comment.align)]: true,
												[textSize(state.comment.size)]: true,
												[textFont(state.comment.font)]: true
											})}
										>
											{state.comment.text}
										</p>
									) : null}

									{state.qrcode.isActive ? (
										<>
											<div className="flex items-center justify-center">
												<img className="h-56" src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg" />
											</div>

											<div className="border border-x-0 border-t-0 border-b-[1.5px] h-3 border-dashed !border-gray-500" />

											<div className="h-[10px]" />
										</>
									) : null}

									{/* {state.bottomOrderNumber.isActive ? (
										<div className="">
											<div className="text-center w-full !pr-2 uppercase">
												{tr("Номер заказа")}
											</div>
											<div className="text-center w-full !pr-2 !text-6xl font-mono font-bold">
												3
											</div>
										</div>
									) : null} */}
								</div>
							</div>

							<div
								className="col-span-8 bg-white "
								style={{ boxShadow: "0px 0px 10px 0 rgba(0,0,0,0.07)" }}
							>
								<div className="product-form">
									<div className="product-form__head">
										<div className="fw-700">{tr("Чек конструктор")}</div>
									</div>

									<div className="product-form__content !space-y-5">
										<div>
											<Field name="file_id">
												{({
													field,
													form: { errors, setFieldValue, touched }
												}) => (
													<div
														className={classNames({
															"tw-border !border-gray-500 p-3 rounded-xl": true,
															"!border-blue-500": state.logo.isActive
														})}
													>
														<div className="flex items-center justify-between !py-1">
															<p className="!my-0 text-xl !font-normal !text-gray-900">
																{tr("Логотип")}
															</p>

															<Switch
																checked={state.logo.isActive}
																onChange={() => {
																	send({
																		logo: {
																			...state.logo,
																			isActive: !state.logo.isActive
																		}
																	});
																}}
															/>
														</div>

														{state.logo.isActive ? (
															<div className="inline-block">
																<Fields.UploadS2
																	type=".png"
																	successCb={data => {
																		setFieldValue(field.name, data);
																	}}
																>
																	{({ loading }) => {
																		return (
																			<div
																				className={`form-field !mb-0 ${touched[field.name] &&
																					errors[field.name]
																					? "form-field--error"
																					: ""
																					}`}
																			>
																				<div
																					className={`form-field__upload ${loading ? "--loading-dark" : ""
																						}`}
																				>
																					{field.value ? (
																						<div className="form-field__preview !m-0">
																							<img
																								src={get(
																									field.value,
																									"thumbnails.small.src"
																								)}
																								alt=""
																							/>
																						</div>
																					) : (
																						<div className="form-field__upload-mask !m-0">
																							<span>{tr("Загрузить фото")}</span>
																						</div>
																					)}
																				</div>
																			</div>
																		);
																	}}
																</Fields.UploadS2>
															</div>
														) : null}
													</div>
												)}
											</Field>
										</div>

										{/* ======= @COMPANY_NAME ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.companyName.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Название компании")}
												</p>

												<Switch
													checked={state.companyName.isActive}
													onChange={() =>
														send({
															companyName: {
																...state.companyName,
																isActive: !state.companyName.isActive
															}
														})
													}
												/>
											</div>

											{state.companyName.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер текста")}
															</div>

															<SelectTextSize
																value={state.companyName.size}
																onChange={e =>
																	send({
																		companyName: {
																			...state.companyName,
																			size: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Выравнивание текста")}
															</div>

															<SelectTextAlign
																value={state.companyName.align}
																onChange={e =>
																	send({
																		companyName: {
																			...state.companyName,
																			align: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Жирность")}
															</div>

															<SelectTextFont
																value={state.companyName.font}
																onChange={e =>
																	send({
																		companyName: {
																			...state.companyName,
																			font: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>
													</div>

													<Input
														className="!border-gray-300"
														placeholder={tr(
															"Введите название вашей компании"
														)}
														size="large"
														value={state.companyName.text}
														onChange={e =>
															send({
																companyName: {
																	...state.companyName,
																	text: e.currentTarget.value
																}
															})
														}
													/>
												</div>
											) : null}
										</div>

										{/* ======= @ORDER_NUMBER ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.orderNumber.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Номер заказа")}
												</p>

												<Switch
													checked={state.orderNumber.isActive}
													onChange={() =>
														send({
															orderNumber: {
																...state.orderNumber,
																isActive: !state.orderNumber.isActive
															}
														})
													}
												/>
											</div>

											{state.orderNumber.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер текста")}
															</div>

															<SelectTextSize
																value={state.orderNumber.size}
																onChange={e =>
																	send({
																		orderNumber: {
																			...state.orderNumber,
																			size: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Выравнивание текста")}
															</div>

															<SelectTextAlign
																value={state.orderNumber.align}
																onChange={e =>
																	send({
																		orderNumber: {
																			...state.orderNumber,
																			align: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Жирность")}
															</div>

															<SelectTextFont
																value={state.orderNumber.font}
																onChange={e =>
																	send({
																		orderNumber: {
																			...state.orderNumber,
																			font: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>
													</div>
												</div>
											) : null}
										</div>

										{/* ======= @ORDER_DATE ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.orderDate.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Дата")}
												</p>

												<Switch
													checked={state.orderDate.isActive}
													onChange={() =>
														send({
															orderDate: {
																...state.orderDate,
																isActive: !state.orderDate.isActive
															}
														})
													}
												/>
											</div>

											{state.orderDate.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер текста")}
															</div>

															<SelectTextSize
																value={state.orderDate.size}
																onChange={e =>
																	send({
																		orderDate: {
																			...state.orderDate,
																			size: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Выравнивание текста")}
															</div>

															<SelectTextAlign
																value={state.orderDate.align}
																onChange={e =>
																	send({
																		orderDate: {
																			...state.orderDate,
																			align: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Жирность")}
															</div>

															<SelectTextFont
																value={state.orderDate.font}
																onChange={e =>
																	send({
																		orderDate: {
																			...state.orderDate,
																			font: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>
													</div>
												</div>
											) : null}
										</div>

										{/* ======= @ORDER_TABLE ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.orderType.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Тип заказа")}
												</p>

												<Switch
													checked={state.orderType.isActive}
													onChange={() =>
														send({
															orderType: {
																...state.orderType,
																isActive: !state.orderType.isActive
															}
														})
													}
												/>
											</div>
										</div>

										{/* ======= @ORDER_TYPE ============ */}
										{/* <div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.orderTable.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													Номер стола
												</p>

												<Switch
													checked={state.orderTable.isActive}
													onChange={() =>
														send({
															orderTable: {
																...state.orderTable,
																isActive: !state.orderTable.isActive
															}
														})
													}
												/>
											</div>
										</div> */}

										{/* ======= @WAITER ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.waiter.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Кассир")}
												</p>

												<Switch
													checked={state.waiter.isActive}
													onChange={() =>
														send({
															waiter: {
																...state.waiter,
																isActive: !state.waiter.isActive
															}
														})
													}
												/>
											</div>
										</div>

										{/* ======= @GOOD_LIST ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.goodList.isCompact
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Заказы (компактный)")}
												</p>

												<Switch
													checked={state.goodList.isCompact}
													onChange={() =>
														send({
															goodList: {
																...state.goodList,
																isCompact: !state.goodList.isCompact
															}
														})
													}
												/>
											</div>
										</div>

										{/* @service */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.service.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Скидка")}
												</p>

												<Switch
													checked={state.service.isActive}
													onChange={() =>
														send({
															service: {
																...state.service,
																isActive: !state.service.isActive
															}
														})
													}
												/>
											</div>
										</div>

										{/* ======= @TOTAL_SUM ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.totalSum.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Итого")}
												</p>

												<Switch
													checked={state.totalSum.isActive}
													onChange={() =>
														send({
															totalSum: {
																...state.totalSum,
																isActive: !state.totalSum.isActive
															}
														})
													}
												/>
											</div>

											{state.totalSum.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер чек другого сотрудника")}
															</div>

															<SelectTextSize
																value={state.totalSum.size}
																onChange={e =>
																	send({
																		totalSum: {
																			...state.totalSum,
																			size: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>
													</div>
												</div>
											) : null}
										</div>

										{/* @TOTAL_SUM_DETAILS */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.totalSumDetails.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Детали оплаты")}
												</p>

												<Switch
													checked={state.totalSumDetails.isActive}
													onChange={() =>
														send({
															totalSumDetails: {
																...state.totalSumDetails,
																isActive: !state.totalSumDetails.isActive
															}
														})
													}
												/>
											</div>
										</div>

										{/* @COMMENT */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.comment.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Комментарий к чеку")}
												</p>

												<Switch
													checked={state.comment.isActive}
													onChange={() =>
														send({
															comment: {
																...state.comment,
																isActive: !state.comment.isActive
															}
														})
													}
												/>
											</div>

											{state.comment.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер чек другого сотрудника")}
															</div>

															<SelectTextSize
																value={state.comment.size}
																onChange={e =>
																	send({
																		comment: {
																			...state.comment,
																			size: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер чек другого сотрудника")}
															</div>

															<SelectTextAlign
																value={state.comment.align}
																onChange={e =>
																	send({
																		comment: {
																			...state.comment,
																			align: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>

														<div>
															<div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Размер чек другого сотрудника")}
															</div>

															<SelectTextFont
																value={state.comment.font}
																onChange={e =>
																	send({
																		comment: {
																			...state.comment,
																			font: e
																		}
																	})
																}
																tr={tr}
															/>
														</div>
													</div>

													<Input
														className="!border-gray-300"
														placeholder={tr(
															"Введите название вашей компании"
														)}
														size="large"
														value={state.comment.text}
														onChange={e =>
															send({
																comment: {
																	...state.comment,
																	text: e.currentTarget.value
																}
															})
														}
													/>
												</div>
											) : null}
										</div>

										{/* @qrcode */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.qrcode.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("QR-код")}
												</p>

												<Switch
													checked={state.qrcode.isActive}
													onChange={() =>
														send({
															qrcode: {
																...state.qrcode,
																isActive: !state.qrcode.isActive
															}
														})
													}
												/>
											</div>
										</div>

										{/* @ORDER_NUMBERS_BIG */}
										{/* <div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.bottomOrderNumber.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													Нижний номер заказа
												</p>

												<Switch
													checked={state.bottomOrderNumber.isActive}
													onChange={() =>
														send({
															bottomOrderNumber: {
																...state.bottomOrderNumber,
																isActive: !state.bottomOrderNumber.isActive
															}
														})
													}
												/>
											</div>
										</div> */}

										{/* ======= @CHEQUE_LANGUAGE ============ */}
										<div
											className={classNames({
												"tw-border !border-gray-500 p-3 rounded-xl": true,
												"!border-blue-500": state.chequeLanguage.isActive
											})}
										>
											<div className="flex items-center justify-between !py-1">
												<p className="!my-0 text-xl !font-normal !text-gray-900">
													{tr("Язык чека")}
												</p>

												<Switch
													checked={state.chequeLanguage.isActive}
													onChange={() =>
														send({
															chequeLanguage: {
																...state.chequeLanguage,
																isActive: !state.chequeLanguage.isActive
															}
														})
													}
												/>
											</div>

											{state.chequeLanguage.isActive ? (
												<div className="space-y-3 !pl-3 !pt-3">
													<div className="flex justify-between">
														<div>
															{/* <div className="fw-400 !mb-1 !ml-1 fs-14">
																{tr("Язык")}
															</div> */}

															<SelectLanguage
																value={state.chequeLanguage.language}
																onChange={e =>
																	send({
																		chequeLanguage: {
																			...state.chequeLanguage,
																			language: e
																		}
																	})
																}
															/>
														</div>
													</div>
												</div>
											) : null}
										</div>

										<Button
											loading={state.isLoading}
											size="large"
											block
											type="primary"
											onClick={() => onSave(values)}
										>
											{tr("Сохранить")}
										</Button>
									</div>
								</div>
							</div>
						</div>
					);
				}}
			</EntityForm.Main>
		</>
	);
};

const WaveTop = () => {
	return (
		<svg
			width="100%"
			height="20"
			viewBox="0 0 1000 20"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="none"
			className="absolute -top-5 w-full left-0 right-0"
		>
			<defs>
				<pattern id="wave" width="40" height="20" patternUnits="userSpaceOnUse">
					<path d="M0 10 Q10 0 20 10 T40 10 L40 20 L0 20 Z" fill="#ffffff" />
				</pattern>
			</defs>
			<rect width="100%" height="20" fill="url(#wave)" />
		</svg>
	);
};

const WaveBottom = () => {
	return (
		<svg
			width="100%"
			height="20"
			viewBox="0 0 1000 20"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="none"
			className="absolute -bottom-5 w-full left-0 right-0"
		>
			<defs>
				<pattern
					id="wave-top"
					width="40"
					height="20"
					patternUnits="userSpaceOnUse"
					patternTransform="scale(1,-1) translate(0,-20)"
				>
					<path d="M0 10 Q10 0 20 10 T40 10 L40 20 L0 20 Z" fill="#ffffff" />
				</pattern>
			</defs>

			<rect width="100%" height="20" fill="url(#wave-top)" />
		</svg>
	);
};
